import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { initialAccountingCreditCardState } from "./CreditCard.types";
import { AccountingCreditCardActions } from ".";
import {
  CLEAR_ACCOUNTING_CREDIT_CARD,
  FETCH_ACCOUNTING_CREDIT_CARD_FAILURE,
  FETCH_ACCOUNTING_CREDIT_CARD_LIST_FAILURE,
  FETCH_ACCOUNTING_CREDIT_CARD_LIST_PROGRESS,
  FETCH_ACCOUNTING_CREDIT_CARD_LIST_SUCCESS,
  FETCH_ACCOUNTING_CREDIT_CARD_PROGRESS,
  FETCH_ACCOUNTING_CREDIT_CARD_SUCCESS,
} from "./CreditCardActions";

export const AccountingCreditCardReducer = (
  state: IStoreState["accounting"]["creditCard"] = initialAccountingCreditCardState,
  action: AccountingCreditCardActions
) => {
  switch (action.type) {
    case FETCH_ACCOUNTING_CREDIT_CARD_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_CREDIT_CARD_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.data = data;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_CREDIT_CARD_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.error = errorMessage;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_CREDIT_CARD_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_CREDIT_CARD_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.Loaded;
        draftState.list = data;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_CREDIT_CARD_LIST_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.Failed;
      });
      return newState;
    }

    case CLEAR_ACCOUNTING_CREDIT_CARD: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.NotLoaded;
        draftState.data = initialAccountingCreditCardState.data;
        draftState.error = null;
      });
      return newState;
    }

    default:
      return state;
  }
};
